require('../../../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js')

export class Fancybox {
  constructor() {
    this.$fBox = $('[data-fancybox]')
  }
  init() {
    this.constructor()

    this.$fBox
    .fancybox({
      animationEffect : "zoom-in-out",
      animationDuration : 300,
      centerOnScroll: true,
      buttons : [
        // 'slideShow',
        // 'fullScreen',
        // 'thumbs',
        // 'share',
        //'download',
        //'zoom',
        'close'
      ],
      helpers: {
        title: null,
      },
      loop : false,
      preload : "auto",
      protect: true,
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/src/fancybox.js